import { configFile } from "@/config";
import { Box, ListItem, OrderedList, Text, Link as ChakraLink } from "@chakra-ui/react";

// @ts-ignore There is no types for this package
import AnchorLink from "react-anchor-link-smooth-scroll-v2";
import kebabCase from 'lodash/kebabCase'
import useTranslation from "next-translate/useTranslation";

function TableOfContent({ props }: any) {
  const { t } = useTranslation('common')
  return (
    <Box>
      <Text
        fontWeight="700"
        fontSize="18px"
        mb="12px"
        className="small-title"
      >
        {t("article.tableOfContents.title")}
      </Text>
      <Box
        width="100%"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
        borderRadius="8px"
        bgColor="#fff"
        overflow="hidden"
        padding="28px"
      >
        <OrderedList
          display="flex"
          marginLeft="0"
          flexDir="column"
          rowGap="24px"
          style={{ counterReset: "item" }}
          listStyleType="none"
        >
          {Object.entries(
            Array.from(
              props.post.data[0].attributes.content.matchAll(
                /^## (.*)$/gm
              )
            )
          ).map(([index, match]) => {
            const headerText: string = (match as [string, string])[1];
            return (
              <ListItem
                key={index}
                style={{ counterIncrement: "item" }}
              >
                <ChakraLink
                  offset="120"
                  display="block"
                  as={AnchorLink}
                  fontWeight="500"
                  fontSize="16px"
                  lineHeight="24px"
                  position="relative"
                  pl="35px"
                  color="gray.600"
                  _hover={{
                    textDecor: "none",
                    color: configFile.primaryAccentColor,
                  }}
                  _before={{
                    content: "counter(item)",
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "24px",
                    height: "24px",
                    bgColor: configFile.secondaryAccentColor,
                    borderRadius: "100%",
                    marginRight: "16px",
                    position: "absolute",
                    left: "0",
                    top: "2px",
                    color: configFile.tertiaryAccentColor,
                    fontWeight: "600",
                  }}
                  href={`#${kebabCase(headerText)}`}
                >
                  {headerText}
                </ChakraLink>
              </ListItem>
            );
          })}
        </OrderedList>
      </Box>
    </Box>
  );
}

export default TableOfContent;